import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'equine-ui-nx-bt-account-added-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './bt-account-added-dialog.component.html',
  styleUrl: './bt-account-added-dialog.component.scss',
})
export class BtAccountAddedDialogComponent implements OnInit {
  message = 1;

  readonly data = inject<{verified: boolean, message?: number, messageError?: string}>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    if (this.data.message === 2) {
      this.message = 2;
    }
  }


}
